<div *ngIf="questionnaire && !(modeRendu.enModeImpression$ | async)">
  <div class="container" *ngIf="ROLES.isHabilite(['gestionnaire'])">
    <i>{{ identifiantValeur }}</i><span *ngIf="libelleJuridictionValeur !== ''"> – {{ libelleJuridictionValeur }}</span>
  </div>
  <div class="container" *ngIf="! ROLES.isHabilite(['gestionnaire'])">
    <span *ngIf="libelleJuridictionValeur !== ''"> {{ libelleJuridictionValeur }}</span>
  </div>
</div>